export class ThirdPartyModuleModel {
  constructor(
    public id: number = null,
    public thirdPartyId: number = null,
    public thirdPartyCodeSap: string = null,
    public moduleId: number = null,
    public module: string = null,
    public checked = false,
    public action: string = null
  ) {}

  fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
